/** Microsoft 365 in the chat: answer cards and the steps line (Phase 15e; MsTakvimYatay, MsMailListe, MsMailEk). */
export const m365ChatTr = {
  name: 'Microsoft 365',
  /** a card the model is still writing */
  pending: 'Kart hazırlanıyor',
  cardFailed: 'Bu kart gösterilemedi; yanıtın geri kalanı yukarıda ve aşağıda.',
  days: { today: 'Bugün', tomorrow: 'Yarın', yesterday: 'Dün', label: '{{day}} · {{weekday}}' },
  duration: {
    hours_one: '{{count}} saat',
    hours_other: '{{count}} saat',
    minutes_one: '{{count}} dk',
    minutes_other: '{{count}} dk',
    hoursMinutes: '{{hours}} saat {{minutes}} dk',
  },
  calendar: {
    source: 'Outlook takviminiz',
    meetings_one: '{{count}} toplantı',
    meetings_other: '{{count}} toplantı',
    noMeetings: 'Toplantı yok',
    total: 'toplam {{duration}}',
    longestGap: 'en uzun boşluk {{from}}–{{to}}',
    free: 'Boş · {{duration}}',
    allDay: 'Tüm gün',
    cancelled: 'İptal edildi',
    teams: 'Teams',
    online: 'Çevrim içi',
    list: 'Toplantılar',
  },
  attendees: {
    onlyYou: 'Yalnız siz',
    one: '{{name}}',
    oneAndYou: '{{name}} ve siz',
    two: '{{first}} ve {{second}}',
    twoAndYou: '{{first}}, {{second}} ve siz',
    many_one: '{{first}}, {{second}} ve {{count}} kişi',
    many_other: '{{first}}, {{second}} ve {{count}} kişi',
  },
  mail: {
    label: 'Mailler: {{title}}',
    /** the card's source beside Microsoft's Outlook icon: "Outlook · Gelen kutusu · 31 Ekim" */
    source: 'Outlook · {{label}}',
    count_one: '{{count}} mail',
    count_other: '{{count}} mail',
    replies_one: '{{count}} yanıt bekliyor',
    replies_other: '{{count}} yanıt bekliyor',
    groups: { reply: 'Yanıt bekleyenler', info: 'Bilgi için' },
    groupHints: { reply: '{{count}} · önce bunlar', info: '{{count}} · yanıt gerekmiyor' },
    waiting: 'Yanıt bekliyor',
    unread: 'Okunmadı',
    attachments: 'Ekler: {{names}}',
    rest_one: '{{count}} mail daha',
    rest_other: '{{count}} mail daha',
    restWith_one: '{{count}} mail daha: {{summary}}',
    restWith_other: '{{count}} mail daha: {{summary}}',
    notListed_one: 'Listelenmeyen {{count}} mail daha var.',
    notListed_other: 'Listelenmeyen {{count}} mail daha var.',
    show: 'Göster',
    hide: 'Gizle',
  },
  attachment: {
    label: 'Mail eki: {{name}}',
    summary: 'Özet',
    /** the mail it came from, beside Microsoft's Outlook icon: "Outlook · Can Aydın'ın maili · Q3 bölge raporu · 30 Eki 11:05" */
    source: 'Outlook · {{label}}',
    fromMail: '{{name}}{{suffix}} maili',
    onlyHere: 'Ek yalnız bu sohbette kullanıldı, belgelerinize eklenmedi.',
    siblings_one: 'Bu mailde bir ek daha var:',
    siblings_other: 'Bu mailde {{count}} ek daha var:',
    page: 's. {{from}}',
    pages: 's. {{from}}–{{to}}',
    slide: 'slayt {{from}}',
    slides: 'slayt {{from}}–{{to}}',
    extent: {
      pages_one: '{{count}} sayfa',
      pages_other: '{{count}} sayfa',
      slides_one: '{{count}} slayt',
      slides_other: '{{count}} slayt',
      sheets_one: '{{count}} sayfa',
      sheets_other: '{{count}} sayfa',
    },
  },
  fileTypes: { pdf: 'PDF', word: 'Word', excel: 'Excel', powerpoint: 'PowerPoint', csv: 'CSV', text: 'Metin', image: 'Görsel', archive: 'Arşiv', other: 'Dosya' },
  // part 3 (D-220…): the mail and meeting cards (MsSohbetOnay, MsToplantiOnay); only "pending" has a mockup
  write: {
    waiting: 'Onayınızı bekliyor',
    kind: { mail: 'Mail', meeting: 'Toplantı', draft: 'Outlook taslağı', asNew: 'Yeni mail' },
    lock: { mail: 'Oppy onaysız mail göndermez', meeting: 'Oppy onaysız toplantı kurmaz' },
    label: { mail: 'Mail', meeting: 'Toplantı' },
    fields: {
      from: 'Kimden',
      to: 'Kime',
      cc: 'Cc',
      subject: 'Konu',
      body: 'Metin',
      title: 'Başlık',
      date: 'Gün',
      start: 'Başlangıç',
      duration: 'Süre (dakika)',
      attendees: 'Katılımcılar',
      note: 'Not',
    },
    noSubject: '(konu yok)',
    external: 'Şirket dışı',
    replyTo: 'Yanıt, gönderenin değil, mailde belirtilen başka bir adrese gider: {{address}}',
    answered: 'Yanıtlanan mail · {{name}}, {{time}}',
    thread: 'Outlook yanıtın altına yanıtlanan maili ve önceki yazışmayı ekler.',
    // v0.16c.6 (D-412…D-416): a reply Microsoft could not open, sent as a new mail
    asNew: {
      quote: 'Yanıtlanan mail',
      attachments: 'Özgün mailin ekleri bu maile eklenmez.',
      separate: "Outlook'ta ayrı bir yazışma olarak görünebilir.",
      asked: 'Yeni mail olarak hazırlandı; kartı aşağıda.',
    },
    source: 'Yanıtlanan mail',
    draftAttachments: 'Taslakla giden ekler',
    footer: {
      mail: 'Gönderince sizin hesabınızdan {{people}} gider.',
      meeting: 'Oluşturunca davet sizin adınıza {{people}} gider.',
      alone: 'Davet kimseye gitmez; yalnız takviminize eklenir.',
    },
    actions: {
      cancel: 'Vazgeç',
      edit: 'Düzenle',
      stopEditing: 'Düzenlemeyi bırak',
      send: 'Gönder',
      create: 'Oluştur ve davet et',
      createAlone: 'Oluştur',
      sending: 'Gönderiliyor…',
      creating: 'Oluşturuluyor…',
      remove: '{{name}} kişisini çıkar',
      add: 'Ekle',
      addAddress: 'E-posta adresi yazın',
      pick: 'Başka saat seç:',
      pickTime: 'Toplantıyı {{time}} olarak seç',
      reconnect: 'Yeniden bağlan',
      asNewMail: 'Yeni mail olarak hazırla',
    },
    state: {
      sent: 'Gönderildi · {{time}}',
      sentNoTime: 'Gönderildi',
      created: 'Oluşturuldu · davetler gönderildi',
      createdAlone: 'Oluşturuldu · takviminize eklendi',
      teams: 'Teams bağlantısı davette',
      teamsAlone: 'Teams bağlantısı takvimde',
      noTeams: 'Teams bağlantısı eklenemedi',
      failed: { mail: 'Gönderilemedi', meeting: 'Oluşturulamadı' },
      unknown: {
        mail: "Gönderilip gönderilmediği bilinmiyor; Outlook'ta Gönderilmiş Öğeler'e bakın.",
        meeting: 'Oluşturulup oluşturulmadığı bilinmiyor; Outlook takviminize bakın.',
      },
      expired: { mail: 'Süresi doldu · gönderilmedi', meeting: 'Süresi doldu · oluşturulmadı' },
      cancelled: { mail: 'Gönderilmedi · vazgeçtiniz', meeting: 'Oluşturulmadı · vazgeçtiniz' },
      stopped: { mail: 'Gönderilmedi · durduruldu', meeting: 'Oluşturulmadı · durduruldu' },
      askAgain: 'İsterseniz sohbette yeniden isteyin; yeni bir kart hazırlanır.',
      // v0.16c.6: createReply refused because Exchange could not read the answered mail (D-415)
      unreadable: {
        title: 'Bu mail yanıt olarak açılamıyor.',
        detail: 'Microsoft, yanıtladığınız mailin bir parçasını (büyük ihtimalle bir eki ya da imzadaki bir resmi) okuyamadı. Yanıtınızı yeni bir mail olarak gönderebilirim.',
      },
      edited: 'Kartta düzenlenen hali gösteriliyor.',
    },
    reasons: {
      draft_changed: "Taslak Outlook'ta değişti; gönderilmedi.",
      verify_mismatch: "Outlook'taki taslak karttakinden farklı çıktı; gönderilmedi. Taslak Taslaklar'da duruyor.",
      microsoft_busy: 'Microsoft şu an çok yoğun.',
      microsoft_forbidden: 'Microsoft bu işleme izin vermedi.',
      microsoft_not_found: { mail: 'Microsoft maili bulamadı.', meeting: 'Microsoft takvimi bulamadı.' },
      microsoft_rejected: 'Microsoft isteği kabul etmedi.',
      microsoft_failed: "Microsoft'ta bir sorun oldu.",
      teams_unavailable: 'Hesabınızda Teams toplantısı açılamıyor.',
      timeout: 'Microsoft zamanında yanıt vermedi.',
      microsoft_unavailable: "Microsoft'a ulaşılamadı.",
      original_unreadable: 'Microsoft yanıtlanan maili okuyamadı.',
      other: 'Microsoft isteği tamamlamadı.',
    },
    // why "Gönder" did not go yet; the card stays as it is and nothing was written
    pending: {
      scopes: 'Yeni izin gerekiyor · yeniden bağlan',
      featureOff: { mail: 'Firmanız mail göndermeyi kapattı', meeting: 'Firmanız toplantı oluşturmayı kapattı' },
      offTeam: 'Microsoft 365 ekibiniz için kapalı',
      off: 'Microsoft 365 sizin için kapalı',
      pilot: 'Deneme kipinde yalnız izin verilen adreslere gönderilebilir',
      changed: 'Bu kart artık gösterildiği gibi değil; sohbetteki son haline bakın.',
      rateLimited: 'Bu saat için gönderme sınırına ulaştınız; biraz sonra yeniden deneyin.',
      unavailable: "Sunucu şu an Microsoft'a ulaşamıyor; hiçbir şey gönderilmedi. Biraz sonra yeniden deneyin.",
      reconnect: 'Microsoft bağlantınızı yenilemeniz gerekiyor · yeniden bağlan',
      notConnected: 'Microsoft hesabınız bağlı değil · yeniden bağlan',
      consent: 'Microsoft, bu izin için şirketinizin yöneticisinin onayını istiyor.',
      lost: "Yanıt alınamadı; kartın son durumu birazdan burada görünür. Outlook'ta Gönderilmiş Öğeler'e de bakabilirsiniz.",
      lostMeeting: 'Yanıt alınamadı; kartın son durumu birazdan burada görünür. Outlook takviminize de bakabilirsiniz.',
      invalid: 'Düzenlemede geçersiz bir alan var; düzeltip yeniden deneyin.',
      tooSoon: 'Toplantının saati geçti ya da çok yaklaştı; başka bir saat seçin.',
      invalidCard: 'Bu kart gönderilemedi; sohbette yeniden isteyin.',
    },
    meeting: {
      time: '{{from}} – {{to}}',
      teams: 'Teams toplantısı · bağlantı otomatik eklenir',
      noTeams: 'Teams bağlantısı eklenemiyor (hesabınızda Teams toplantısı yok)',
      organizer: 'düzenleyen',
      availability: { free: 'bu saatte boş', busy: 'bu saatte dolu', unseen: 'takvimi görülemedi', unchecked: 'takvime bakılmadı' },
      notChecked: 'Bu saat için takvimlere bakılmadı.',
      noSchedule: 'Takvimlere bakılamadı; katılımcıların uygunluğu bilinmiyor.',
      duration: {
        minutes_one: '{{count}} dakika',
        minutes_other: '{{count}} dakika',
        hours_one: '{{count}} saat',
        hours_other: '{{count}} saat',
        hoursMinutes: '{{hours}} saat {{minutes}} dakika',
      },
      strip: {
        title: '{{whose}}, {{when}}',
        when: '{{day}} {{part}}',
        whose: {
          '1': 'Takviminiz',
          '2': 'İkinizin takvimi',
          '3': 'Üçünüzün takvimi',
          '4': 'Dördünüzün takvimi',
          '5': 'Beşinizin takvimi',
          '6': 'Altınızın takvimi',
          '7': 'Yedinizin takvimi',
          '8': 'Sekizinizin takvimi',
          '9': 'Dokuzunuzun takvimi',
          '10': 'Onunuzun takvimi',
          many: '{{count}} kişinin takvimi',
        },
        day: { today: 'bugün', tomorrow: 'yarın' },
        part: { morning: 'öğleden önce', afternoon: 'öğleden sonra' },
        legend: { busy: 'dolu', selected: 'seçilen', alternative: 'başka uygun' },
        cell: '{{from}}–{{to}} · {{state}}',
        state: {
          busy: 'dolu',
          selected: 'seçilen · herkes boş',
          selectedBusy_one: 'seçilen · {{count}} kişi dolu',
          selectedBusy_other: 'seçilen · {{count}} kişi dolu',
          alternative: 'başka uygun · herkes boş',
          free: 'herkes boş',
        },
      },
    },
    problems: {
      to: 'En az bir alıcı yazın.',
      tooMany: 'Bir mailde en çok 25 alıcı olabilir.',
      duplicate: 'Bir adres bir kez yazılabilir.',
      address: 'Geçerli bir e-posta adresi yazın.',
      pendingAddress: 'Yazdığınız adresi Ekle ile ekleyin ya da silin; eklenmeyen adrese gönderilmez.',
      subject: 'Konu en çok 255 karakter olabilir.',
      subjectLine: 'Konu tek satır olmalı.',
      body: 'Metin en çok 20.000 karakter olabilir.',
      title: 'Toplantıya en çok 255 karakterlik bir başlık yazın.',
      date: 'Geçerli bir gün seçin.',
      start: 'Geçerli bir başlangıç saati seçin.',
      duration: 'Süre 15 ile 480 dakika arasında olmalı.',
      attendees: 'Bir toplantıda en çok 19 katılımcı olabilir.',
      note: 'Not en çok 4.000 karakter olabilir.',
    },
    broken: 'Bu kart gösterilemedi; hiçbir şey gönderilmedi. Göndermek için sohbette yeniden isteyin.',
  },
};

/** Steps line verbs of the built-in tools, merged into `steps.tools` (the label from the server wins when done). */
export const m365StepToolsTr = {
  mcp__microsoft365__mail_ara: { running: 'Mailler aranıyor', done: 'Mailler arandı' },
  mcp__microsoft365__mail_oku: { running: 'Mail okunuyor', done: 'Mail okundu' },
  mcp__microsoft365__eki_oku: { running: 'Ek okunuyor', done: 'Ek okundu' },
  mcp__microsoft365__takvime_bak: { running: 'Takvime bakılıyor', done: 'Takvime bakıldı' },
  mcp__microsoft365__toplanti_ayrintisi: { running: 'Toplantıya bakılıyor', done: 'Toplantıya bakıldı' },
  mcp__microsoft365__uygun_saat_bul: { running: 'Uygun saat aranıyor', done: 'Uygun saatler bulundu' },
  // part 3: a write tool prepares a card; `prepared` is the steps line's word while that card waits (MsSohbetOnay)
  mcp__microsoft365__yanit_taslagi: { running: 'Yanıt hazırlanıyor', done: 'Yanıt hazırlandı', prepared: 'Taslak yazıldı' },
  mcp__microsoft365__taslagi_gonder: { running: 'Taslak hazırlanıyor', done: 'Taslak hazırlandı', prepared: 'Taslak hazırlandı' },
  mcp__microsoft365__mail_gonder: { running: 'Mail hazırlanıyor', done: 'Mail hazırlandı', prepared: 'Mail hazırlandı' },
  mcp__microsoft365__toplanti_olustur: { running: 'Toplantı hazırlanıyor', done: 'Toplantı hazırlandı', prepared: 'Toplantı hazırlandı' },
};
